// Clases de los controles que van sobre la barra superior (`Navbar`). La barra
// es azul en claro y oscura en oscuro (`bar`), así que todo lo que va encima
// lleva el texto, el hover y el foco de la barra (`bar-fg`, `bar-hover`), como
// en Effetá Apps. El contorno del foco lo pone `*:focus-visible` en
// `globals.css`; acá solo cambia su color.

// Botón o enlace de solo icono: tema, ayuda, Effetá Apps.
export const BAR_ICON_BUTTON_CLASS =
  'text-bar-fg hover:bg-bar-hover focus-visible:outline-bar-fg inline-flex h-9 w-9 items-center justify-center rounded-full transition-colors';

// Control con texto (selector de área): un borde tenue para que se lea como
// control sobre el azul.
export const BAR_TEXT_BUTTON_CLASS =
  'border-bar-fg/30 text-bar-fg hover:bg-bar-hover focus-visible:outline-bar-fg inline-flex h-9 items-center gap-2 rounded-md border px-3 text-sm transition-colors';
